'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var forms = require('@grandvisionhq/forms');
var state = require('@grandvisionhq/state');
var slots = require('@grandvisionhq/slots');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const DefaultSignUpForm = ()=>{
    const { getLabel  } = state.useIntl();
    return /*#__PURE__*/ React__default["default"].createElement(forms.Email, {
        label: getLabel('fields.input.email.label'),
        errorMessage: getLabel('account.error.emailInvalid'),
        required: true
    });
};

const [PersonalDetailsTemplatesSlotsProvider, usePersonalDetailsTemplatesSlots, ] = slots.createSlotsContext({
    displayName: 'PersonalDetailsTemplatesSlotsContext'
});

const [SignUpTemplatesSlotsProvider, useSignUpTemplatesSlots] = slots.createSlotsContext({
    displayName: 'SignUpTemplatesSlotsContext'
});

exports.DefaultSignUpForm = DefaultSignUpForm;
exports.PersonalDetailsTemplatesSlotsProvider = PersonalDetailsTemplatesSlotsProvider;
exports.SignUpTemplatesSlotsProvider = SignUpTemplatesSlotsProvider;
exports.usePersonalDetailsTemplatesSlots = usePersonalDetailsTemplatesSlots;
exports.useSignUpTemplatesSlots = useSignUpTemplatesSlots;
//# sourceMappingURL=index.js.map
